//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { CurtainTransitionBasic } from '~/assets/js/transitions.js'
import PostContent from '~/components/posts/PostContent'
import ContactForm from '~/components/layout/ContactForm'
export default {

	mixins: [ CurtainTransitionBasic ],

    colorMode: 'light',

	components: {
		PostContent,ContactForm
	},
    
    data() {
      return {
        needContactForm : this.$store.state.needContactForm
      }
    },

	async asyncData({ $axios, store, params, app }) {
		store.commit('NEED_CONTACT_FORM', (params.slug =='contact'))
		const page = await $axios.$get('wp/v2/pages',{
			params: { slug: params.slug, per_page: 1, lang:app.i18n.locale}
		})
		store.commit('CURRENT_POST_UPDATE', page[0])
		store.commit('FILTER_BY_CAT', null)
	},

	head () {
		return {
			bodyAttrs: {
				class: 'page'
			}
		}
	}
}
